'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var index$1 = require('../../00.helper/FormField/index.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Input = require('../Input/Input.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-select',
    cnLight = "".concat(CLASSNAME, "--light"),
    cnWrapperSelect = "".concat(CLASSNAME, "__wrapper-select"),
    cnSelect = "".concat(CLASSNAME, "__select"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnTitleBold = "".concat(cnTitle, "--bold"),
    cnTitleError = "".concat(cnTitle, "--error"),
    cnDisabled = "".concat(CLASSNAME, "--disabled"),
    cnError = "".concat(CLASSNAME, "--error"),
    cnFocus = "".concat(CLASSNAME, "--focus");
var OTHER_VALUE = -9999;
/**
 * 
 */

var Select = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Select, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Select);

  function Select() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {});

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onChange", function (e) {
      var target = e.target;

      if (target.value - 0 === OTHER_VALUE) {
        _this.setState({
          showInput: true
        });

        return;
      }

      var _this$props = _this.props,
          onChange = _this$props.onChange,
          options = _this$props.options,
          value = _this.findDeep(options, target.value);

      _this.setState({
        extraItem: undefined
      });

      _this.validate(e);

      onChange(value);
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onFocus", function () {
      _this.setState({
        focus: true
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onBlur", function (e) {
      var error = _this.state.error;

      if (error) {
        _this.validate(e);
      }

      _this.setState({
        focus: false
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onInputBlur", function (value) {
      var extraItem = value ? {
        value: value,
        label: value
      } : undefined,
          onChange = _this.props.onChange;

      _this.setState({
        showInput: false,
        extraItem: extraItem
      });

      if (extraItem) {
        onChange(extraItem);
      }

      _this.onBlur({
        target: {
          value: value
        }
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "validate", function (e) {
      var value = e.target.value,
          required = _this.props.required;

      if (required && !value) {
        _this.setState({
          error: true
        });

        return;
      }

      _this.setState({
        error: false
      });
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Select, [{
    key: "findDeep",
    value: function findDeep(data, value) {
      return data.map(function (item) {
        if (item.options) {
          return item.options;
        }

        return item;
      }) // .flat()
      .reduce(function (acc, val) {
        return acc.concat(val);
      }, []).find(function (item) {
        return item.value === value;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          style = _this$props2.style,
          className = _this$props2.className,
          name = _this$props2.name,
          title = _this$props2.title,
          options = _this$props2.options,
          placeholder = _this$props2.placeholder,
          disabled = _this$props2.disabled,
          value = _this$props2.value,
          defaultValue = _this$props2.defaultValue,
          iconSize = _this$props2.iconSize,
          bold = _this$props2.bold,
          light = _this$props2.light,
          required = _this$props2.required,
          tabIndex = _this$props2.tabIndex,
          other = _this$props2.other,
          otherTitle = _this$props2.otherTitle,
          innerRef = _this$props2.innerRef,
          onKeyUp = _this$props2.onKeyUp,
          errorTitle = _this$props2.errorTitle,
          requiredLabel = _this$props2.requiredLabel,
          optionalLabel = _this$props2.optionalLabel;
      var _this$state = this.state,
          showInput = _this$state.showInput,
          _this$state$extraItem = _this$state.extraItem,
          extraItem = _this$state$extraItem === void 0 ? {} : _this$state$extraItem,
          error = _this$state.error,
          focus = _this$state.focus; // TODO optgroups are not selectable

      var selected = this.findDeep(options, value) || value;
      var defaultSelected = this.findDeep(options, defaultValue) || defaultValue;

      if (!(selected || extraItem.value) && other) {
        extraItem.value = value || defaultValue;
        extraItem.label = value || defaultValue;
      }

      if (showInput) {
        return /*#__PURE__*/React__default.createElement(Input, _rollupPluginBabelHelpers.extends({}, this.props, {
          innerRef: function innerRef(el) {
            return el ? el.focus() : null;
          },
          onBlur: this.onInputBlur,
          onFocus: this.onFocus,
          onInvalid: this.validate
        }));
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME, className, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnDisabled, disabled), _rollupPluginBabelHelpers.defineProperty(_classNames, cnError, error), _rollupPluginBabelHelpers.defineProperty(_classNames, cnFocus, focus), _rollupPluginBabelHelpers.defineProperty(_classNames, cnLight, light), _classNames)),
        style: style,
        onKeyUp: onKeyUp
      }, /*#__PURE__*/React__default.createElement("label", null, title && /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnTitle, _rollupPluginBabelHelpers.defineProperty({}, cnTitleBold, bold))
      }, title, required ? requiredLabel : optionalLabel), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapperSelect
      }, /*#__PURE__*/React__default.createElement("select", {
        required: required,
        className: cnSelect,
        onChange: this.onChange,
        disabled: disabled,
        name: name,
        value: defaultValue,
        defaultValue: defaultSelected,
        tabIndex: tabIndex,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onInvalid: this.validate,
        ref: innerRef,
        "aria-label": title
      }, extraItem.value ? /*#__PURE__*/React__default.createElement("option", {
        value: extraItem.value
      }, extraItem.label) : /*#__PURE__*/React__default.createElement("option", {
        value: "",
        disabled: true,
        hidden: true
      }, placeholder), options.map(function (item, i) {
        return !item.options ? /*#__PURE__*/React__default.createElement("option", {
          key: i,
          value: item.value || item.Value
        }, item.label || item.title || placeholder) : /*#__PURE__*/React__default.createElement("optgroup", {
          label: item.label || item.title,
          key: i
        }, item.options.map(function (option, j) {
          return /*#__PURE__*/React__default.createElement("option", {
            key: j,
            value: option.value || option.Value
          }, option.label || option.title || placeholder);
        }));
      }), other && /*#__PURE__*/React__default.createElement("option", {
        value: OTHER_VALUE
      }, otherTitle)), /*#__PURE__*/React__default.createElement(Icon, {
        className: classNames(cnIcon),
        id: (selected || {}).icon || 'caret-down',
        size: iconSize
      })), /*#__PURE__*/React__default.createElement("div", {
        className: cnTitleError
      }, errorTitle, "\xA0")));
    }
  }]);

  return Select;
}(React__default.Component);
Select.propTypes = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.propTypes), {}, {
  bold: PropTypes.bool,

  /** Additional class name */
  className: PropTypes.string,

  /** */
  defaultValue: PropTypes.any,

  /** True if disabled */
  disabled: PropTypes.bool,

  /** Text on error */
  errorTitle: PropTypes.string,
  // why is this breaking the build process?
  // iconSize: Icon.propTypes.size,

  /** Ref of inner element */
  innerRef: PropTypes.any,

  /** True for light style */
  light: PropTypes.bool,

  /** Name in form */
  name: PropTypes.string,

  /** Callback function */
  onChange: PropTypes.func,

  /** Callback function on key up */
  onKeyUp: PropTypes.func,

  /** Array of options to display in dropdown */
  options: PropTypes.array.isRequired,

  /** */
  otherTitle: PropTypes.string,

  /** True for custom input */
  other: PropTypes.bool,

  /** Placeholder text */
  placeholder: PropTypes.string,

  /** True for required in form */
  required: PropTypes.bool,

  /** Additional styles object */
  style: PropTypes.object,

  /** */
  tabIndex: PropTypes.any,

  /** Label above input */
  title: PropTypes.string,

  /** Current value */
  value: PropTypes.any
});
Select.defaultProps = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.defaultProps), {}, {
  iconSize: 'xs',
  onChange: function onChange() {
    return null;
  },
  onKeyUp: function onKeyUp() {
    return null;
  },
  options: [],
  otherTitle: 'other',
  placeholder: '---'
});

module.exports = Select;
